// SavedRecentSearch.jsx

import React from "react";

export const SavedRecentSearch = () => (
  <div className="ml-6 w-80 bg-gray-200 shadow-md rounded-lg p-6">
    
    {/* Search Candidates Button */}
    <div className="flex items-center justify-between mb-6">
      <button
        type="submit"
        className="bg-[#0077B5]  hover:bg-[#0077B5]  text-white font-bold py-2 px-4 rounded w-full sm:w-auto"
      >
        Search Candidates
      </button>
    </div>

    {/* Recent Searches */}
    <h2 className="text-lg font-bold text-gray-700 mb-4">Recent Searches</h2>
    <div>
      <ul className="list-disc pl-5 space-y-2">
        <li>React Developer</li>
        <li>Full Stack Engineer</li>
      </ul>
    </div>
    
    {/* Saved Searches */}
    <h2 className="text-lg font-bold text-gray-700 mt-6 mb-4">Saved Searches</h2>
    <div>
      <ul className="list-disc pl-5 space-y-2">
        <li>Java Developer</li>
        <li>DevOps Engineer</li>
      </ul>
    </div>
  </div>
);
